export default __webpack_public_path__ + "static/media/excel_dark.c18ea6ca.svg";